export class MatPaginationModel {
    pageSize:number;
    pageIndex:number;
    pageSizeOptions:number[];
  
    constructor() {
        this.pageSize = 10;
        this.pageIndex = 0;
        this.pageSizeOptions = [5, 10, 25];
    }
  }